import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { useCallback } from 'react';
import type { NeukundenObjektErstellenMutation, NeukundenObjektErstellenMutationVariables } from './__generated__/NeukundenObjektErstellenMutation';
export type { NeukundenObjektFragment as NeukundenObjekt } from './__generated__/NeukundenObjektErstellenMutation';

export const useNeukundenObjektErstellenMutation = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const [executeMutation, { loading, error }] = useMutation<NeukundenObjektErstellenMutation, NeukundenObjektErstellenMutationVariables>(gql`
    mutation neukundenObjektErstellen($name: String!, $strasse: String!, $ort: String!, $postleitzahl: String, $gedatId: String) {
      neukundenObjektErstellen(name: $name, strasse: $strasse, ort: $ort, postleitzahl: $postleitzahl, gedatId: $gedatId) {
        ...NeukundenObjekt
      }
    }
    fragment NeukundenObjekt on Objekt {
      id,
      name,
      adresse {
        ort,
        postleitzahl,
        strasse
      }
    }
  `, {
    onError: handleWithErrorNotification('Das Erstellen des Neukunden Objekts ist fehlgeschlagen.'),
    update(cache) {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'neukundenObjektErstellen' });
    },
  });

  return {
    execute: useCallback((variables: NeukundenObjektErstellenMutationVariables) => executeMutation({ variables }), [executeMutation]),
    loading,
    error,
  };
};
